/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Read_EInputs */

const en_testimonial_read_e = /** @type {(inputs: Testimonial_Read_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Great app! Helpful for academics. I've been using this app to listen to scholarly articles, and it's great. Works as promised: good at skipping content that doesn't need to be read aloud; good at translating niche terms into audio. Highly recommend for anyone who has to read a lot of academic content.`)
};

const es_testimonial_read_e = /** @type {(inputs: Testimonial_Read_EInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Gran app! Útil para académicos. He estado usando esta app para escuchar artículos académicos, y es genial. Funciona como se promete: buena para omitir contenido que no necesita leerse en voz alta; buena para traducir términos especializados a audio. Muy recomendable para cualquiera que tenga que leer mucho contenido académico.`)
};

/**
* | output |
* | --- |
* | "Great app! Helpful for academics. I've been using this app to listen to scholarly articles, and it's great. Works as promised: good at skipping content that ..." |
*
* @param {Testimonial_Read_EInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_read_e = /** @type {((inputs?: Testimonial_Read_EInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Read_EInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_read_e(inputs)
	return en_testimonial_read_e(inputs)
});